module.exports = __webpack_public_path__ + "img/x1.c786c0f5.svg";